<script setup>
import { noImage } from '@/common/helper'
import { useCatalogState } from '../composables/CatalogState'

const {
  rowsFiltered,
  allowImageFallback,
  nearestParentCategorySmallImageUrl,
  selectArticle,
} = useCatalogState();
</script>

<template>
  <!-- Display mode: list -->
  <div class="relative grid grid-cols-1 gap-4 w-full mt-2 mb-32">
    <a href="#" v-for="(row, i) in rowsFiltered" @click.prevent="selectArticle(row)" class="py-4 flex bg-white border border-gray-200 rounded-lg shadow hover:border-blue-600 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700">

      <!-- Article image -->
      <div class="grid place-items-center text-center w-24 mx-4 dark:bg-white dark:p-1 dark:rounded-md" style="width: 50px; height: 50px" v-if="row.thumbnailUrl">
        <img :src="row.thumbnailUrl" alt="" class="w-full" />
      </div>
      <!-- <div class="grid place-items-center text-center w-24 mx-4" style="width: 50px; height: 50px" v-else-if="allowImageFallback && currentCategoryImageUrl">
        <img :src="currentCategoryImageUrl" alt="" style="max-width: 50px; max-height: 50px;" />
      </div> -->
      <div class="grid place-items-center text-center w-24 mx-4" style="width: 50px; height: 50px" v-else-if="allowImageFallback && nearestParentCategorySmallImageUrl">
        <img :src="nearestParentCategorySmallImageUrl" alt="" style="max-width: 50px; height: 50px;" />
      </div>
      <!-- :class="{ 'text-blue-200': selectedItemId == row.id && promptDeleteItemId != row.id, 'text-red-300': promptDeleteItemId == row.id }" -->
      <div class="grid place-items-center text-gray-200 dark:text-gray-900 text-center w-24 mx-4" style="font-size: 48px; width: 50px; height: 50px;" v-else>
        <i class="fa fa-image"></i>
      </div>

      <!-- Article name and SKU -->
      <div class="w-full pr-5 flex flex-row justify-between items-center gap-2">
        <div>
          <h5 class="text-md tracking-tight text-gray-900 dark:text-white" v-if="row.name">{{ row.name }}</h5>
          <h3 class="mt-0 text-slate-400" v-if="row.sku">{{ row.sku }}</h3>
        </div>
        <div v-if="!row.isVaultItem">
          <h5 class="text-gray-500">{{ row.totalQuantity > 0 ? row.totalQuantity : 0 }}&nbsp;kos</h5>
          <h3 v-if="row.sku">&nbsp;</h3>
        </div>
      </div>

    </a>
  </div>
</template>